(function () {
	'use strict';

	// TODO: Seems it's obsolete. Get rid of it.

	angular.module('mx.components').component('mxGridEditFormField', {
		bindings: {
			field: '=',
			entity: '=',
		},
		controller: MxGridEditFormFieldCtrl,
		controllerAs: 'vm',
		templateUrl: 'mx-grid/mx-grid-edit-form-field.html',
	});

	MxGridEditFormFieldCtrl.$inject = [];
	function MxGridEditFormFieldCtrl() {
		var vm = this;
		vm.$onInit = function () {
			vm.isString = isString;
			vm.isBool = isBool;
		};
		return vm;

		function isString() {
			return vm.field.type === 'string';
		}

		function isBool() {
			return vm.field.type === 'boolean';
		}
	}
})();
